import angular from 'angular';
import _ from 'lodash';
import StoreServiceFactory from '../store.factory';

const merchantDetailServiceFactory = function MerchantDetailServiceFactory($q,NewBackendService, endPoints, $log, StoreService){
						"ngInject";
				let serviceObject = {
					getMerchantDetail: function(userId, shopId, isBackground){
						const url = `${endPoints.deviceUrl}/devices/search`
						const storeId = shopId ? shopId : StoreService.getSelectedStore().id;
						return $q(function(resolve, reject) {
							NewBackendService.invokeWebApiGet(url, {"businessId": userId, "shopId": storeId, "page": 0, "size": 1000}, isBackground).then(function(result){
								var devices = result.data._embedded ? result.data._embedded.merchantDevices : []
								resolve(devices)
							},
							function(error){
								reject (error);
							})
						});
					},
					
					changeBusinessData: function(businessId, businessObj, isBackground){
						const url = `${endPoints.userUrl}/users/me/businesses/${businessId}`;
						return $q(function (resolve, reject){
							let request = [
								{"op": "replace", "path": "/company", "value": businessObj.company},
								{"op": "replace", "path": "/sdlCode", "value": businessObj.sdlCode},
								{"op": "replace", "path": "/pecEmail", "value": businessObj.pecEmail},
							]
							if(businessObj.corporateEmail) request.push({"op": "replace", "path": "/corporateEmail", "value": businessObj.corporateEmail})
							NewBackendService.invokeWebApiPatch(url, request, isBackground).then(function (result) {
								resolve(result.data);
							}, function (error) {
								reject(error);
							});
						});
					},
					getShopById: function(businessId, shopId){
						return $q(function (resolve, reject){
							NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/businesses/${businessId}/shops/${shopId}`).then(res => {
								resolve(res.data);
							}, function (error) {
								reject(error);
							});
						})
					},
				};
				return serviceObject;
			}

export default merchantDetailServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/merchantDetail.factory.js
 **/